import React, { useEffect } from 'react';
import { Route, Switch, BrowserRouter } from 'react-router-dom';
import axios from 'axios';

import PrivateRoute from './components/common/PrivateRoute';
import PublicLayout from './components/layout/PublicLayout';
import PrivateLayout from './components/layout/PrivateLayout';

import { BACKEND_CONFIG } from './config/consts';

const App = React.memo(() => {
  useEffect(() => {
    axios
      .get(`${BACKEND_CONFIG.apiUrl}account/environment-mode`)
      .then(response => {
        BACKEND_CONFIG.set(
          'startApplicationPageComponent',
          response.data.StartApplicationPageComponent,
        );
        BACKEND_CONFIG.set('brandCode', response.data.BrandCode);
        BACKEND_CONFIG.set('busUnitId', response.data.BusUnitId);
      });

    window.dispatchEvent(new window.Event('backendConfigChange'));
  }, []);

  return (
    <BrowserRouter>
      <Switch>
        <Route path="/login" component={PublicLayout} />
        <PrivateRoute path="/" component={PrivateLayout} />
      </Switch>
    </BrowserRouter>
  );
});

export default App;
